import { ConnectionType } from 'connection'

export const BACKFILLABLE_WALLETS = [ConnectionType.INJECTED]
